import { render, staticRenderFns } from "./NoTransactionTable.vue?vue&type=template&id=265508e6&scoped=true&"
import script from "./NoTransactionTable.vue?vue&type=script&lang=js&"
export * from "./NoTransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265508e6",
  null
  
)

export default component.exports